module.exports = __webpack_public_path__ + "4963e8e03ea961792b01bfe74dc26e48.png";